import classNames from 'classnames';
import { FieldValues, Path, RegisterOptions, useFormContext } from 'react-hook-form';
import TextAreaField, { TextAreaProps } from '../TextAreaField/TextAreaField';
import './FormTextArea.scss';

type FormTextAreaProps<TFormValues extends FieldValues> = {
  name: Path<TFormValues>;
  type?: string;
  rules?: RegisterOptions;
  label: string;
  value?: string;
  editable?: boolean;
  limit?: number;
} & Omit<TextAreaProps, 'name'>;

const FormTextArea = <TFormValues extends Record<string, unknown>>({
  name,
  rules,
  className,
  value,
  editable,
  limit,
  ...props
}: FormTextAreaProps<TFormValues>): JSX.Element => {
  const { register, formState } = useFormContext();
  const { errors } = formState;
  const hasError = errors?.[name];
  const errorMessage = errors?.[name]?.message;
  const errorText = typeof errorMessage === 'string' ? errorMessage : null;

  return (
    <div className={classNames('form-textarea', className)} aria-live="polite">
      <TextAreaField
        {...props}
        className={classNames()}
        value={value}
        hasError={!!hasError}
        {...(register && register(name, { ...rules, required: true, maxLength: limit }))}
        readOnly={!editable}
        limit={limit}
      />
      <p className="error-message">{hasError ? errorText : null}</p>
    </div>
  );
};

export default FormTextArea;
